// extracted by mini-css-extract-plugin
export var aiStarSpin = "_md-1";
export var spinner = "_md-0";